/*
  Quiet header. See snippets/quiet-header.liquid.

  - Colour: the white and charcoal layers are clipped to the parts of the header over dark
    and light sections, so the colour and the veil change exactly on a section edge.
  - Hover and focus are mirrored onto both layers, so nothing jumps at the colour line.
  - Shop: the fill starts where the cursor comes in and drains where it leaves, with a
    slight magnetic pull.
  - Past the hero the wordmark tucks into the V; the header steps aside while you scroll
    down and returns as soon as you scroll up.
  - Cart: opens the theme's cart drawer, and the count follows the theme's own cart icon.
  - Phones and tablets (when switched on): Menu, the V and Cart. Menu opens the frosted
    glass over the whole screen. The glass is a modal dialog whose edge is moved frame by
    frame, and it carries a charcoal copy of the bar, so the header changes colour exactly
    on the edge as it passes. Press a link and slide your thumb: each one rolls as you pass
    it, and letting go opens it.
*/
(function () {
  var root = document.querySelector('[data-quiet-header]');
  if (!root || root.dataset.quietReady) return;
  root.dataset.quietReady = 'true';

  var header = root.closest('header-component') || root.parentElement;
  var desktop = window.matchMedia('(min-width: 990px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var phones = root.hasAttribute('data-quiet-phones');

  // Whether the quiet header is on screen at this width.
  function active() {
    return desktop.matches || phones;
  }

  function each(key, fn) {
    root.querySelectorAll('[data-k="' + key + '"]').forEach(fn);
  }

  function setState(key, name, on) {
    each(key, function (el) {
      el.classList.toggle(name, on);
    });
  }

  function pointIn(el, event) {
    var r = el.getBoundingClientRect();
    return { x: event.clientX - r.left, y: event.clientY - r.top, w: r.width, h: r.height };
  }

  function keyOf(node) {
    var el = node && node.closest ? node.closest('[data-k]') : null;
    return el && root.contains(el) ? el : null;
  }

  // ---------- hover and focus, mirrored on both layers ----------
  root.addEventListener('pointerover', function (event) {
    var el = keyOf(event.target);
    if (!el) return;
    if (el.dataset.k === 'shop' && !el.classList.contains('is-hot')) {
      // Move the empty circle to the entry point without animating, then let it grow.
      var p = pointIn(el, event);
      each('shop', function (cta) {
        var over = cta.querySelector('.quiet-cta__over');
        over.style.transition = 'none';
        cta.style.setProperty('--x', p.x + 'px');
        cta.style.setProperty('--y', p.y + 'px');
        over.getBoundingClientRect();
        over.style.transition = '';
      });
    }
    setState(el.dataset.k, 'is-hot', true);
  });

  root.addEventListener('pointerout', function (event) {
    var el = keyOf(event.target);
    if (!el) return;
    var to = keyOf(event.relatedTarget);
    if (to && to.dataset.k === el.dataset.k) return;
    if (el.dataset.k === 'shop') {
      var p = pointIn(el, event);
      each('shop', function (cta) {
        cta.style.setProperty('--x', p.x + 'px');
        cta.style.setProperty('--y', p.y + 'px');
        cta.style.setProperty('--mx', '0px');
        cta.style.setProperty('--my', '0px');
      });
    }
    setState(el.dataset.k, 'is-hot', false);
  });

  root.addEventListener('pointermove', function (event) {
    var el = keyOf(event.target);
    if (!el || el.dataset.k !== 'shop') return;
    var p = pointIn(el, event);
    var mx = (p.x / p.w - 0.5) * 8;
    var my = (p.y / p.h - 0.5) * 6;
    each('shop', function (cta) {
      cta.style.setProperty('--mx', mx.toFixed(2) + 'px');
      cta.style.setProperty('--my', my.toFixed(2) + 'px');
    });
  });

  root.addEventListener('focusin', function (event) {
    var el = keyOf(event.target);
    if (!el) return;
    setState(el.dataset.k, 'is-hot', true);
    if (el.matches(':focus-visible')) setState(el.dataset.k, 'is-focus', true);
    root.classList.remove('is-away');
  });

  root.addEventListener('focusout', function (event) {
    var el = keyOf(event.target);
    if (!el) return;
    setState(el.dataset.k, 'is-hot', false);
    setState(el.dataset.k, 'is-focus', false);
  });

  // ---------- clicks: cart, and the phone menu ----------
  function openCart(event) {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || typeof drawer.showDialog !== 'function') return false;
    event.preventDefault();
    drawer.showDialog();
    return true;
  }

  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-k="menu"]')) {
      event.preventDefault();
      if (menuOpen) closeMenu();
      else openMenu();
      return;
    }
    if (event.target.closest('[data-quiet-close]')) {
      event.preventDefault();
      closeMenu();
      return;
    }
    if (event.target.closest('[data-k="sheet-cart"]')) {
      // The drawer opens over the menu, and the menu closes out of sight underneath it.
      if (openCart(event)) {
        setTimeout(function () {
          closeMenu(true);
        }, 450);
      }
      return;
    }
    if (event.target.closest('[data-k="cart"]')) openCart(event);
  });

  var source = document.querySelector('cart-icon .cart-bubble__text-count');
  var shown = root.querySelector('.quiet-count__now');
  shown = shown ? shown.textContent.trim() : '0';

  function readCount() {
    var text = source ? source.textContent.trim() : '';
    return text === '' ? '0' : text;
  }

  function showCount(next) {
    if (next === shown) return;
    shown = next;
    root.querySelectorAll('[data-quiet-count-label]').forEach(function (label) {
      label.textContent = label.textContent.replace(/,.*$/, ', ' + next);
    });
    root.querySelectorAll('[data-quiet-count]').forEach(function (count) {
      var stack = count.querySelector('.quiet-count__stack');
      var now = count.querySelector('.quiet-count__now');
      if (next === '0') {
        count.hidden = true;
        now.textContent = next;
        return;
      }
      if (count.hidden) {
        count.hidden = false;
        now.textContent = next;
        return;
      }
      count.querySelector('.quiet-count__next').textContent = next;
      count.classList.add('is-rolling');
      setTimeout(function () {
        now.textContent = next;
        stack.classList.add('is-reset');
        count.classList.remove('is-rolling');
        requestAnimationFrame(function () {
          stack.classList.remove('is-reset');
        });
      }, 600);
    });
  }

  if (source) {
    new MutationObserver(function () {
      showCount(readCount());
    }).observe(source, { childList: true, characterData: true, subtree: true });
  }

  // ---------- colour, tuck and step-aside ----------
  var darkRegions = [];
  var hero = null;

  function isDark(color) {
    var m = color && color.match(/rgba?\(([^)]+)\)/);
    if (!m) return false;
    var p = m[1].split(',').map(parseFloat);
    if (p.length === 4 && p[3] < 0.5) return false;
    return (0.2126 * p[0] + 0.7152 * p[1] + 0.0722 * p[2]) / 255 < 0.45;
  }

  // Dark areas: anything marked data-header-tone="dark", plus sections with a dark background.
  function collect() {
    darkRegions = Array.prototype.slice.call(document.querySelectorAll('[data-header-tone="dark"]'));
    document.querySelectorAll('.shopify-section:not(.shopify-section-group-header-group)').forEach(function (section) {
      if (section.querySelector('[data-header-tone]')) return;
      var bg = section.querySelector('.section-background') || section;
      if (isDark(getComputedStyle(bg).backgroundColor)) darkRegions.push(section);
    });
    hero = null;
    darkRegions.forEach(function (el) {
      if (!hero && el.getBoundingClientRect().top + window.scrollY < 10) hero = el;
    });
  }

  var lastY = window.scrollY;
  var queued = false;

  function paint() {
    queued = false;
    if (!active()) return;

    var H = root.offsetHeight;
    var top = header.getBoundingClientRect().top;

    // The dark stretch of the header, as [start, end] from its top edge.
    var start = null;
    var end = null;
    darkRegions.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var a = Math.max(0, r.top - top);
      var b = Math.min(H, r.bottom - top);
      if (b > a) {
        start = start === null ? a : Math.min(start, a);
        end = end === null ? b : Math.max(end, b);
      }
    });

    var light = [0, 0];
    var dark = [0, H];
    if (start !== null) {
      light = [start, end];
      if (start <= 0 && end >= H) dark = [0, 0];
      else if (start <= 0) dark = [end, H];
      else if (end >= H) dark = [0, start];
      else dark = start > H - end ? [0, start] : [end, H];
    }
    root.style.setProperty('--l-t', light[0] + 'px');
    root.style.setProperty('--l-b', H - light[1] + 'px');
    root.style.setProperty('--d-t', dark[0] + 'px');
    root.style.setProperty('--d-b', H - dark[1] + 'px');
    root.classList.toggle('is-veiled', dark[1] >= H && dark[0] < H);

    var y = window.scrollY;
    var heroBottom = hero ? hero.getBoundingClientRect().bottom - top : null;
    root.classList.toggle('is-tucked', hero ? heroBottom < H * 0.5 : y > 80);

    var reading = hero ? heroBottom < -40 : y > 240;
    var drawerOpen = document.querySelector('.cart-drawer__dialog[open]');
    if (reading && y > lastY + 6 && !drawerOpen && !menuOpen && !root.contains(document.activeElement)) {
      root.classList.add('is-away');
    } else if (y < lastY - 6 || !reading) {
      root.classList.remove('is-away');
    }
    lastY = y;
  }

  function queue() {
    if (!queued) {
      queued = true;
      requestAnimationFrame(paint);
    }
  }

  function refresh() {
    collect();
    queue();
  }

  // ---------- the phone menu ----------
  var sheet = root.querySelector('[data-quiet-sheet]');
  var menuButton = root.querySelector('.quiet-header__layer--light [data-k="menu"]');
  var menuOpen = false;
  var edge = 0;
  var raf = 0;
  var closeTimer = 0;

  // The ease used everywhere else in the header, cubic-bezier(0.76, 0, 0.24, 1).
  function bezier(x1, y1, x2, y2) {
    function at(t, p1, p2) {
      return (1 - 3 * p2 + 3 * p1) * t * t * t + (3 * p2 - 6 * p1) * t * t + 3 * p1 * t;
    }
    function slope(t, p1, p2) {
      return 3 * (1 - 3 * p2 + 3 * p1) * t * t + 2 * (3 * p2 - 6 * p1) * t + 3 * p1;
    }
    return function (x) {
      if (x <= 0) return 0;
      if (x >= 1) return 1;
      var lo = 0;
      var hi = 1;
      var t = x;
      for (var i = 0; i < 24; i++) {
        var v = at(t, x1, x2) - x;
        if (Math.abs(v) < 1e-5) break;
        if (v > 0) hi = t;
        else lo = t;
        var s = slope(t, x1, x2);
        var n = s ? t - v / s : -1;
        t = n > lo && n < hi ? n : (lo + hi) / 2;
      }
      return at(t, y1, y2);
    };
  }
  var ease = bezier(0.76, 0, 0.24, 1);

  function setEdge(px) {
    edge = px;
    sheet.style.setProperty('--edge', px + 'px');
  }

  function pour(to, duration, done) {
    cancelAnimationFrame(raf);
    var from = edge;
    var start = performance.now();
    if (reduce.matches) duration = 0;
    function step(now) {
      var t = duration ? Math.min(1, (now - start) / duration) : 1;
      setEdge(from + (to - from) * ease(t));
      if (t < 1) raf = requestAnimationFrame(step);
      else if (done) done();
    }
    step(start);
  }

  function setExpanded(open) {
    if (!menuButton) return;
    menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  }

  function openMenu() {
    if (!sheet || menuOpen || desktop.matches) return;
    menuOpen = true;
    clearTimeout(closeTimer);
    root.classList.remove('is-away');
    setEdge(0);
    if (!sheet.open) sheet.showModal();
    document.documentElement.classList.add('quiet-menu-open');
    // Let the copy of the bar take the header's current state first, so both roll together.
    sheet.getBoundingClientRect();
    root.classList.add('is-open');
    setExpanded(true);
    pour(sheet.clientHeight, 820);
  }

  // instant: skip the pour, e.g. when the cart drawer has opened on top.
  function closeMenu(instant) {
    if (!sheet || !menuOpen) return;
    menuOpen = false;
    root.classList.remove('is-open');
    setExpanded(false);
    setSheetHot(null);
    clearTimeout(closeTimer);

    function finish() {
      var hadFocus = sheet.contains(document.activeElement);
      if (sheet.open) sheet.close();
      document.documentElement.classList.remove('quiet-menu-open');
      if (hadFocus && !instant && menuButton) menuButton.focus({ preventScroll: true });
      queue();
    }

    if (instant) {
      cancelAnimationFrame(raf);
      setEdge(0);
      finish();
      return;
    }
    closeTimer = setTimeout(function () {
      pour(0, 640, finish);
    }, 150);
  }

  var sheetHot = null;
  var pressed = false;
  var lastTouch = 0;

  function setSheetHot(link) {
    if (sheetHot === link) return;
    if (sheetHot) sheetHot.classList.remove('is-hot');
    sheetHot = link;
    if (sheetHot) sheetHot.classList.add('is-hot');
  }

  if (sheet) {
    var list = sheet.querySelector('[data-quiet-sheet-links]');
    var cta = sheet.querySelector('[data-quiet-sheet-cta]');

    sheet.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeMenu();
    });

    var linkAt = function (event) {
      var el = document.elementFromPoint(event.clientX, event.clientY);
      return el && el.closest ? el.closest('.quiet-sheet__link') : null;
    };

    var go = function (link) {
      setSheetHot(link);
      if (link.getAttribute('aria-current') === 'page') {
        // Already here: close the menu and go back to the top instead of reloading.
        closeMenu();
        window.scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' });
        return;
      }
      window.location.href = link.href;
    };

    // Touch: press a link and slide, and each rolls as your thumb passes it; letting go
    // opens the one under it. A mouse just hovers and clicks.
    list.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse') return;
      pressed = true;
      lastTouch = Date.now();
      try {
        list.setPointerCapture(event.pointerId);
      } catch (error) {}
      setSheetHot(linkAt(event));
    });

    list.addEventListener('pointermove', function (event) {
      if (event.pointerType === 'mouse' || pressed) setSheetHot(linkAt(event));
    });

    list.addEventListener('pointerup', function (event) {
      if (event.pointerType === 'mouse') return;
      pressed = false;
      lastTouch = Date.now();
      var link = linkAt(event);
      if (link) go(link);
      else setSheetHot(null);
    });

    list.addEventListener('pointercancel', function () {
      pressed = false;
      setSheetHot(null);
    });

    list.addEventListener('pointerleave', function (event) {
      if (event.pointerType === 'mouse') setSheetHot(null);
    });

    list.addEventListener('focusin', function (event) {
      setSheetHot(event.target.closest('.quiet-sheet__link'));
    });

    list.addEventListener('focusout', function () {
      setSheetHot(null);
    });

    list.addEventListener('click', function (event) {
      var link = event.target.closest('.quiet-sheet__link');
      if (!link) return;
      // A touch was already handled when the finger lifted.
      if (Date.now() - lastTouch < 700) {
        event.preventDefault();
        return;
      }
      if (link.getAttribute('aria-current') === 'page') {
        event.preventDefault();
        go(link);
      }
    });

    // Shop now: the fill spreads from under your thumb (or where the cursor comes in).
    if (cta) {
      var over = cta.querySelector('.quiet-sheet__cta-over');

      var ctaPoint = function (event) {
        var r = cta.getBoundingClientRect();
        return {
          x: event.clientX - r.left,
          y: event.clientY - r.top,
          inside: event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom,
        };
      };

      var bloom = function (p) {
        over.style.transition = 'none';
        cta.style.setProperty('--x', p.x + 'px');
        cta.style.setProperty('--y', p.y + 'px');
        over.getBoundingClientRect();
        over.style.transition = '';
        cta.classList.add('is-hot');
      };

      var drain = function (p) {
        if (p) {
          cta.style.setProperty('--x', p.x + 'px');
          cta.style.setProperty('--y', p.y + 'px');
        }
        cta.classList.remove('is-hot');
      };

      cta.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse') bloom(ctaPoint(event));
      });
      cta.addEventListener('pointerup', function (event) {
        // Lifting off the button cancels; lifting on it follows the link as normal.
        if (event.pointerType === 'mouse') return;
        var p = ctaPoint(event);
        if (!p.inside) drain(p);
      });
      cta.addEventListener('pointercancel', function () {
        drain(null);
      });
      cta.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'mouse') bloom(ctaPoint(event));
      });
      cta.addEventListener('pointerleave', function (event) {
        if (event.pointerType === 'mouse') drain(ctaPoint(event));
      });
    }

    // Coming back with the back button can restore the page with the menu still open.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        closeMenu(true);
        if (cta) cta.classList.remove('is-hot');
      }
    });
  }

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', refresh);
  window.addEventListener('load', refresh);
  function onBreakpoint() {
    if (desktop.matches) closeMenu(true);
    refresh();
  }
  if (desktop.addEventListener) desktop.addEventListener('change', onBreakpoint);
  refresh();
})();
